import labels from './labels/en';
import maps from './maps/en';

export const common = {
  plsEnter: 'Please enter ',
  plsSelect: 'Please choose '
};

export default {
  kline: {
    '0m': 'Minute',
    '1m': '1 min',
    '5m': '5 min',
    '15m': '15 min',
    '30m': '30 min',
    '1h': '1 hour',
    '1d': '1 day',
    '1w': '1 week'
  },
  depositStatus: {
    0: 'Pending',
    1: 'Recharge successful',
    2: 'Credit failed'
  },
  withdrawStatus: {
    0: 'Under review',
    1: 'Success',
    2: 'Refuse',
    3: 'Revoke',
    4: 'examination passed',
    5: 'In progress',
    6: 'Wallet abnormal, under review'
  },
  map: {
    orderCategory: {
      1: 'Buy',
      2: 'Sell'
    },
    orderType: {
      1: 'Limit',
      2: 'Market'
    },
    myOrderStatus: {
      0: 'Open',
      1: 'Completed',
      2: 'Cancelled'
    }
  },

  links: {
    announcement: 'https://grxtrade.s2.udesk.cn/hc/sections/20628?api_name=',
    fees: 'https://grxtrade.s2.udesk.cn/hc/sections/20631?api_name=',
    webGuide: 'https://grxtrade.s2.udesk.cn/hc/sections/20515?api_name=',
    appGuide: 'https://grxtrade.s2.udesk.cn/hc/sections/20612?api_name='
  },

  'about.title': 'About GRXTrade',
  'about.desc':
    'State-of-the-art digital asset exchange with the lowest trading fees and the most lucrative Affiliate program in the industry. Enjoy the best of both benefits under one platform.',
  'about.learnMore': 'Learn more',

  'advanced.lvl2Verf': 'Level 2 Verification',
  'advanced.address.info': 'Residential Address',
  'advanced.address.proofOfAddress':
    'Proof of address documents: documents issued by local authorities and property-related bills or bank-issued documents (full page, name must match the submission of level 1 verification)',
  'advanced.address.building': 'Building',
  'advanced.address.street': 'Street',
  'advanced.address.district': 'District',
  'advanced.address.province': 'Province',
  'advanced.address.zipCode': 'Zip Code',
  'advanced.address.city': 'City',
  'advanced.address.authImgUrl1': 'Please upload a proof of address document',
  'advanced.address.successSave': 'Residential Address is successfully saved',

  'advanced.employment.info': 'Employment Information',
  'advanced.employment.proofOfIncomeDocuments':
    'Proof of income documents: payroll,bank statement, tax declaration, and loan agreement (full page,name must match the submission of level 1 verification)',
  'advanced.employment.employStatus': 'Employment Status',
  'advanced.employment.sourceIncome': 'Source of Income',
  'advanced.employment.sourceIncomeName': 'Source of Income Name',
  'advanced.employment.industry': 'Industry',
  'advanced.employment.industryName': 'Industry Name',
  'advanced.employment.jobTitle': 'Job Title',
  'advanced.employment.companyName': 'Company Name',
  'advanced.employment.employerBuilding': 'Office Address',
  'advanced.employment.employerStreet': 'Street',
  'advanced.employment.employerZipCode': 'Zip Code',
  'advanced.employment.employerCity': 'City',
  'advanced.employment.employerDistrict': 'District',
  'advanced.employment.employerProvince': 'Province',
  'advanced.employment.authImgUrl2': 'Upload Proof of Income/Salary Slip',
  'advanced.employment.successSave': 'Employment Information is successfully saved',

  'affiliate.title': 'Affiliate Program',
  'affiliate.title.desc': 'Maximize Profit and Returns',
  'affiliate.actions.joinNow': 'Join Now',
  'affiliate.desc.1':
    'GRXTrade lets you maximize your trading growth potential and profitability with the Affiliate Program feature.',
  'affiliate.desc.2':
    'Anyone can be part of our Affiliate Program! Start earning immediately with our lucrative program structure. Traders will receive a minimum of 20%  for direct referrals and up to a cumulative maximum of 40% in commission. And these earnings don’t stop. Commission keeps generating  as long as your referral Affiliates remain active.',
  'affiliate.desc.3':
    'Some competitors offer similar benefits but only for a limited period. At GRXTrade, our Affiliate Program runs indefinitely.',
  'affiliate.desc.4':
    'Why wait? Expand your trading potential today and scale limitless heights with GRXTrade’s Affiliate Program.',
  'affiliate.whyJoin.title': 'Why join the Affiliate Program?',
  'affiliate.whyJoin.desc.1': 'Best-in-industry commission rates and bonuses',
  'affiliate.whyJoin.desc.2': 'Premium status to enjoy exclusive privileges and receive first-hand information',
  'affiliate.whyJoin.desc.3': 'A dedicated account manager to support your business development',
  'affiliate.whyJoin.desc.4': 'Leverage on our sophisticated Affiliate Program platform to grow your market exponentially',
  'affiliate.whyJoin.desc.5': 'No time limit commission earning potential',
  'affiliate.works.title': 'How does the Affiliate Program work?',
  'affiliate.works.desc':
    'Much more than just a digital asset exchange offering global users financial-grade digital asset asset trading and asset management services, GRXTrade is built with value-adding programs for investors to enjoy sustainable income generation through our Affilate and educational programs.',
  'affiliate.works.notes': 'Notes:',
  'affiliate.works.tip.1': 'Online video courses are Chinese-language based. We will roll out English language courses in due time.',
  'affiliate.works.tip.2': 'Exclusive rewards applicable to Senior Affiliate and Top Affiliate only.',
  'affiliate.sharing.title': 'AFFILIATE PROFIT SHARING SYSTEM',
  'affiliate.sharing.normal.title': 'Normal Affiliate',
  'affiliate.sharing.senior.title': 'Senior Affiiate',
  'affiliate.sharing.top.title': 'Top Affiliate',
  'affiliate.sharing.top.notEligible': 'Not eligible for learning rewards',
  'affiliate.sharing.top.earnReward': 'Earn learning rewards of up to 40% from each direct layer',
  'affiliate.sharing.joining.fee': 'No joining fee',
  'affiliate.sharing.commission.20': 'Enjoy 20% commission from direct referrals',
  'affiliate.sharing.commission.20.senior': 'Enjoy 20% commission from direct referrals',
  'affiliate.sharing.fee.200': 'Fee:  200 USDT/year',
  'affiliate.sharing.commission.1st.level': 'Enjoy 10% commission from 1st level indirect referrals',
  'affiliate.sharing.fee.rebate': 'Enjoy 100% annual fee rebate towards trading activities',
  'affiliate.sharing.fee.rebate2': 'Enjoy 100% annual fee rebate towards trading activities',
  'affiliate.sharing.fee.300': 'Fee:  300 USDT/year',
  'affiliate.sharing.commission.2nd.level': 'Enjoy 10% commission from 2nd level indirect referrals',
  'affiliate.sharing.wdec': 'Access to WDEC (Chinese languaged-based education site) for learning opportunities',
  'affiliate.sharing.wdec2': 'Access to WDEC (Chinese languaged-based education site) for learning opportunities',

  // TODO :: Translate Chinese (affiliate)
  'affiliateInvite.title': 'GRXTrade Affiliate Program',
  'affiliateInvite.seniorAffiliate': 'Senior Affiliate',
  'affiliateInvite.seniorAffiliate.memberFee': 'Member fee ',
  'affiliateInvite.topAffiliate': 'Top Affiliate',
  'affiliateInvite.title.desc.1': 'A account manager will be allocated to all qualifying VIP users, providing 24/7 dedicated support.',
  'affiliateInvite.title.desc.2': 'VIP users can find the contact details of their account manager in the VIP Account Center after login.',
  'affiliateInvite.btn': 'Join Now',
  'affiliateInvite.upgrade': 'Upgrade Now',
  'affiliateInvite.joinAffiliateProgram.title': 'Join Affiliate Program',
  'affiliateInvite.joinAffiliateProgram.desc': 'To continue, MAX-Wallet will share your Identity Information with grxtrade.com. Before using this app, you may review our terms of Use.',

  'affiliateInvite.joinAffiliateModal.affiliateLevel': 'Affiliate Level: ',
  'affiliateInvite.joinAffiliateModal.fee': 'Join Fee: ',
  'affiliateInvite.joinAffiliateModal.termsAndCondition': `By clicking on this, you agree to <a href="/legal/affiliate-policy" target="_blank" style="color: #1E49AC">Affiliate's Terms of Conditions</a>`,
  'affiliateInvite.joinAffiliateModal.mustCheckText': 'You must agree with the terms and condition to proceed',
  'affiliateInvite.joinAffiliateModal.balance': 'My Asset Balance:',

  'actions.back': 'Back',
  'actions.cancel': 'Cancel',
  'actions.contactUs': 'Contact Us',
  'actions.copy': 'Copy',
  'actions.copyAll': 'Copy All',
  'actions.export': 'Export',
  'actions.filter': 'Filter',
  'actions.confirm': 'Confirm',
  'actions.close': 'Close',
  'actions.delete': 'Delete',
  'actions.reject': 'Reject',
  'actions.download': 'Download',
  'actions.login': 'Login',
  'actions.loginNow': 'Login Now',
  'actions.loginMaxWallet': 'Login With MAX-Wallet',
  'actions.registMaxWallet': 'Register With MAX-Wallet',
  'actions.registNow': 'Register Now',
  'actions.register': 'Register',
  'actions.renew': 'Renew',
  'actions.save': 'Save',
  'actions.sendEmailOtp': 'Send Email OTP',
  'actions.sendOtp': 'Send OTP',
  'actions.submit': 'Submit',
  'actions.tradeCancel': 'Cancel',
  'actions.tradeCancelAll': 'Cancel All',
  'actions.deposit': 'Deposit',
  'actions.withdraw': 'Withdraw',
  'actions.setup': 'Setup',
  'actions.modify': 'Modify',
  'actions.search': 'Search',

  // TODO :: Translate Chinese (affiliate)
  'actions.payNow': 'Pay Now',
  'actions.payingNow': 'Paying Now',

  'common.selectCountry': 'Select Country',
  'common.loading': 'Loading',
  'common.noRecords': 'No Record Found',
  'common.recordsPerPage': 'Records per page',
  'common.all': 'All',
  'common.expired': 'Expired',
  'common.validUntil': 'Valid until',
  'common.verifyCount': '{time} resend',
  'common.userCount': 'Sum Users',
  'common.noData': '',
  'common.rowPerPage': 'Rows per page',

  'company.profile.title': 'COMPANY PROFILE',
  'company.profile.desc.1':
    'GRXTrade is a next-generation digital asset trading service platform. Conceptualization began in 2017 which took two years to bring to fruition',
  'company.profile.desc.2':
    'Our vision is to shape future global economies by creating a Industry 4.0 - ready digital asset financial center with focus on blockchain technology offering a user-centric platform that incorporates multiple trading options, has 24/7 personal customer support services and exceptional platform security features.',
  'company.profile.vision': 'OUR VISION',
  'company.profile.vision.desc.1':
    'Too many crypto-exchanges in the market offer traders too many choices, making it confusing in selecting the most ideal platform to trade on. Too many available exchange platforms also causes lowered liquidity because the financial market is scattered. Many exchange platforms apply restriction on certain countries barring participation and to make things worse, some exchange platforms may be managed by fraudulent exchange operators.',
  'company.profile.vision.desc.2':
    'At GRXTrade, we strive to raise the bar by offering international markets and traders with top-of-the-line market trading fees and the most sought-after trading pairs. Our exchange platform has shared liquidity through a network of exchanges out there, eliminating possible risks of low liquidity issues.',
  'company.profile.features': 'OUR FEATURES',
  'company.profile.features.subheader': 'What makes GRXTrade so unique from the other crypto-exchange platforms?',
  'company.profile.features.title.1': 'Security',
  'company.profile.features.title.2': 'Lowest Trading Fees',
  'company.profile.features.title.3': 'Affiliate Program',
  'company.profile.features.title.4': 'Intelligent Trader',
  'company.profile.features.desc.1':
    'Founded by a group of global techpreneurs with a common vision to nurture the idea of offering blockchain-based fintech products for inclusive and ethically-governed financial access opportunities. ',
  'company.profile.features.desc.2':
    'Incepted in 2017, GRXTrade envisions to shape future global digital economies by continuously pioneering new ways to benefit everyday people in connecting fintech with traditional finance utilizing comprehensive and intelligent financial instruments.',
  'company.profile.features.desc.3':
    'The founding team comprises of talents from the financial and IT industries supported by a global panel of veterans with more than 15 years in the respective industries, serving as advisors who are from the Foreign Exchange, financial sector, digital asset trading and Information Technology industries. Our integrated administrative and technology teams are decentralized - and we have presence stretching across several major cities in Taiwan, China, Singapore, Korea, Japan and the United Arab Emirates.',
  'company.profile.features.desc.4':
    'The team toyed with the idea of developing a digital asset exchange platform that delivers more than just standard product features of a trading platform. Taking a little less than three years in the making, GRXTrade, an innovative and European regulatory conforming platform that is above and beyond a digital asset trading platform,  is set to debut in the first quarter of 2020.',
  'company.profile.last.word': 'INVEST TODAY FOR YOUR FUTURE WITH GRXTRADE TODAY',

  'contactUs.title': 'CONTACT US',
  'contactUs.desc.1':
    'For further enquiries, you may email directly to',
  'contactUs.desc.2':
    'We endeavor to respond to all enquiries within 24 hours. We highly appreciate your kind understanding  should any delays occur.',
  'contactUs.desc.3':
    'Please be assured that our customer support team are professionally trained to handle customers’ concerns.',

  'dealProfessional.kLine.text': 'Kline',
  'dealProfessional.depth.text': 'Depth',
  'dealProfessional.original.text': 'Original',
  'dealProfessional.buyEntrust': 'Buy',
  'dealProfessional.sellEntrust': 'Sell',
  'dealProfessional.price': 'Price',
  'dealProfessional.sum': 'Sum',

  'fee.title': 'GRXTrade Trading Fees Structure',
  'fee.desc.1': 'We offer the',
  'fee.lowest': 'LOWEST',
  'fee.desc.2': 'trading fees in the industry.',
  'fee.desc.3': 'Trade with GRXTrade to maximize your profitability and returns.',
  'fee.reference.text': 'The table below is the trading fee structure for your reference.',
  'fee.vip.level.title': 'VIP Level',
  'fee.trade.volume.title': '30d Trade Volume (USDT)',
  'fee.all.zone.title': 'All Zones',
  'fee.maker.title': 'Maker',
  'fee.taker.title': 'Taker',
  'fee.vip.normal': 'Normal',
  'fee.vip.level.1': 'Level 1',
  'fee.vip.level.2': 'Level 2',
  'fee.vip.level.3': 'Level 3',
  'fee.vip.level.4': 'Level 4',
  'fee.vip.level.5': 'Level 5',
  'fee.volume.1.million': '0 ≤ 1 mil Volume',
  'fee.volume.5.million': '1 mil ≤ Volume ≤ 5 mil',
  'fee.volume.35.million': '5 mil ≤ Volume ≤ 35 mil',
  'fee.volume.100.million': '35 mil ≤ Volume ≤ 100 mil',
  'fee.volume.300.million': '100 mil ≤ Volume ≤ 300 mil',
  'fee.volume.over.300.million': '≥ 300 mil',
  'fee.withrawal.title': 'Withdraw Fee',
  'fee.withrawal.asset.type': 'Asset Type',
  'fee.withrawal.withdrawal.fees': 'Withdrawal Fees',
  'fee.withrawal.min.withdraw': 'Minimum Withdrawal',
  'fee.withrawal.term.1': '* The transaction fee will be deducted from your total transaction amount.',
  'fee.withrawal.term.2': '* Fees are regularly adjusted according to market conditions. ',
  'fee.withrawal.term.3': '* All the information given above is up-dated.',

  'footer.aboutGrx': 'About GRXTrade',
  'footer.aboutGrx.aboutUs': 'About Us',
  'footer.aboutGrx.contactUs': 'Contact Us',
  'footer.aboutGrx.companyProfile': 'Company Profile',
  'footer.aboutGrx.affProgram': 'Affiliate Program',
  'footer.aboutGrx.fees': 'Fees',
  'footer.aboutGrx.teamProfile': 'Leadership',
  'footer.aboutGrx.helpCenter': 'Help Center',
  'footer.aboutGrx.helpCenter.web': 'Web',
  'footer.aboutGrx.helpCenter.app': 'Mobile App',

  'footer.legal': 'Legal',
  'footer.legal.termsOfUse': 'Terms of Use',
  'footer.legal.amlPolicy': 'AML CFT Policy',
  'footer.legal.riskStatement': 'Risk Disclosure Statement',
  'footer.legal.privacyPolicy': 'Privacy Policy',
  'footer.legal.affiliatePolicy': 'Affiliate Policy',
  'footer.legal.partnerPolicy': 'Partner Policy',

  'header.assets': 'Assets',
  'header.downloadApp': 'Download App',
  'header.exchange': 'Exchange',
  'header.login': 'Login',
  'header.markets': 'Market',
  'header.register': 'Register',
  'header.orders': 'Orders',
  'header.announcement': 'Announcement',
  'header.helpCenter': 'Help Center',

  'header.user.drop.verification': 'ID Verification',
  'header.user.drop.fee.setting': 'Fee Setting',
  'header.user.drop.invite': 'Invite Friends',
  'header.user.drop.member.level': 'Member Level',
  'header.user.drop.vip.level': 'VIP',
  'header.user.drop.30d.vol': '30D Vol',
  'header.user.drop.logout': 'Logout',

  'labels.actions': 'Action',
  'labels.reminder': 'Gentle Reminder',
  'labels.confirmation': 'Confirmation',
  'labels.confirmPwd': 'Confirm password',
  'labels.country': 'Country',
  'labels.date': 'Date',
  'labels.joinDate': 'Joined Date',
  'labels.cdate': 'Date Created',
  'labels.mdate': 'Date Updated',
  'labels.email': 'Email',
  'labels.emailOtp': 'Email OTP',
  'labels.mobileNo': 'Mobile number',
  'labels.unbind': 'Unbind',
  'labels.ga': 'Google Authentication',
  'labels.gaCode': 'Google authentication code',
  'labels.orderId': 'Order ID',
  'labels.tradeId': 'Trade ID',
  'labels.pwd': 'Password',
  'labels.setup': 'Setup',
  'labels.view': 'View',
  'labels.txnPwd': 'Transaction Password',
  'labels.loading': 'Loading',
  'labels.language': 'Language',
  'labels.add': 'Add',
  'labels.uid': 'UID',
  'labels.postDate': 'Post Date:',
  // TODO Translate Chinese Start
  'labels.feeCategory': 'Fee Category',
  'labels.commissionsEarned': 'Commissions Earned',
  // TODO Translate Chinese End
  'labels.reset': 'Reset',
  'labels.here': 'Here',
  'labels.maxRegister': 'Authorize MAX-Wallet Login',
  'labels.transaction.assetType': 'Asset Type',
  'labels.transaction.from': 'From',
  'labels.transaction.to': 'To',
  'labels.transaction.time': 'Time',
  'labels.transaction.coin': 'Coin',
  'labels.transaction.id': 'Transaction ID',
  'labels.transaction.type': 'Type',
  'labels.transaction.total': 'Total',
  'labels.transaction.freeze': 'Freeze',
  'labels.transaction.remark': 'Remark',
  'labels.transaction.freezeamount': 'Total Freeze Amount',
  'labels.transaction.availablebalance': 'Available Balance',
  'labels.transaction.freezeAsset': 'Freeze Asset',
  'labels.transaction.availableAsset': 'Available Asset',
  'labels.transaction.beforeAmount': 'Before Amount',
  'labels.transaction.changeAmount': 'Change Amount',
  'labels.transaction.afterAmount': 'After Amount',
  'labels.transaction.fee': 'Fee',
  'labels.transaction.today': 'Today',
  'labels.transaction.sevenday': '7 day',
  'labels.transaction.fifteen': '15 day',
  'labels.transaction.thirty': '30 day',
  'labels.transaction.all': 'All',
  'labels.transaction.search': 'Search',

  'labels.trade.market': 'Market',
  'labels.trade.coinOrders': 'My Orders',
  'labels.trade.buy': 'Buy ',
  'labels.trade.sell': 'Sell ',
  'labels.trade.pair': 'Pair',
  'labels.trade.side': 'Side',
  'labels.trade.type': 'Type',
  'labels.trade.amt': 'Amount',
  'labels.trade.dealAmt': 'Executed Amount',
  'labels.trade.dealVol': 'Executed Volume',
  'labels.trade.history.vol': 'Volume',
  'labels.trade.vol': 'Volume',
  'labels.trade.price': 'Price',
  'labels.trade.orderVol': 'Volume',
  'labels.trade.orderPrice': 'Price',
  'labels.trade.avgPrice': 'Average Price',
  'labels.trade.change': 'Change',
  'labels.trade.24change': '24H Change',
  'labels.trade.24high': '24H High',
  'labels.trade.24low': '24H Low',
  'labels.trade.24vol': '24H Volume',
  'labels.trade.limit': 'Limit Order',
  'labels.trade.tradeHistory': 'Trade History',
  'labels.trade.time': 'Time',
  'labels.trade.latestPrice': 'Latest Price',
  'labels.trade.startTrade': 'Start Trading',
  'labels.trade.add.sessionTxnPwd': 'Remember Me',
  'labels.trade.depth': 'Depth',
  'labels.trade.fee': 'Trading Fee',
  'labels.trade.rebate': 'Rebate',
  'labels.trade.paidFee': 'Paid Fee',
  'labels.trade.resultAmt': 'Received Amount',

  'labels.reward.title': 'Registration Bonus Available',
  'labels.reward.human': 'persons',
  'labels.reward.10.mxw': 'Get your 10 MXW now!',
  'labels.reward.tnc': 'Terms and Conditions To Fulfill:',
  'labels.reward.tnc.1': '1. User must complete both the registration and the KYC process that requires real-name authentication',
  'labels.reward.tnc.2': '2. Invite at least 1 friend to sign up on GRXTrade',

  'labels.status': 'Status',
  'labels.openOrders': 'Open Orders',
  'labels.or': 'OR',
  'labels.orderHistory': 'Order History',
  'labels.orders': 'Orders',
  'labels.otp': 'OTP',
  'labels.remarks': 'Remarks',

  'labels.scanQrCode': 'Scan QR Code in Max-Wallet App to verify',
  'labels.wechatQrCode': 'Official Customer Service Group',

  'labels.finance.coinToCoinAcc': 'Assets Management',
  'labels.finance.coin': 'Coin',
  'labels.finance.available': 'Available',
  'labels.finance.freeze': 'Freeze',
  'labels.finance.total': 'Total',
  'labels.finance.records': 'Financial Statement',
  'labels.finance.transaction': 'All Transactions',
  'labels.finance.addrMgmt': 'Wallet Management',
  'labels.finance.walletAddr': 'Address',
  'labels.finance.depositAddr': 'Deposit Address',
  'labels.finance.withdrawalAddr': 'Withdrawal Address',
  'labels.finance.memo': 'Memo',
  'labels.finance.memo.notes': '(Incorrect entry may cause asset loss, please check carefully)',
  'labels.finance.depositRecords': 'Deposit Records',
  'labels.finance.withdrawRecords': 'Withdrawal Records',
  'labels.finance.actualAmt': 'Actual Amount',
  'labels.finance.qty': 'Quantity',
  'labels.finance.fee': 'Fee',
  'labels.finance.recharge.tips':
    'The wallet address and its corresponding MEMO (unique identifier tag) must be filled in correctly to ensure that the coin is deposited onto the GRXTrade platform. If the MEMO is not included when depositing, your deposit will be lost.',
  'labels.finance.withdraw.riskWarning': 'Important Reminder',
  'labels.finance.withdraw.riskWarning.desc.1':
    'Once the withdrawal process is completed, the corresponding assets will belong to the owner of the designated wallet address.',
  'labels.finance.withdraw.riskWarning.desc.2':
    'Please double check to ensure confirmation of the withdrawal address details before making a withdrawal. You acknowledge that this withdrawal is a voluntary and legitimate act, and confirm that no pyramid schemes, illegal fundraising and other fraudulent acts are involved. Please be mindful to avoid deception in preventing property losses.',

  'labels.acc.inviteFriend': 'Invite Friend',
  'labels.acc.upgradeToa': 'Level Upgrade',
  'labels.acc.feeLevel': 'VIP fee level',
  'labels.acc.kyc': 'KYC verification',
  'labels.acc.advKyc': 'High level verification',
  'labels.acc.pass': 'Successful',
  'labels.acc.notPass': 'Unsuccessful',
  'labels.acc.securitySettings': 'Security Settings',
  'labels.acc.bindEmail': 'Bind Email',
  'labels.acc.bindEmail.desc': 'Get the latest weekly technical analysis, news and promotions',
  'labels.acc.ga.desc':
    'You must enter a valid Google verification code for  asset withdrawals, resetting passwords, and security settings',
  'labels.acc.ga.desc2':
    'Google Authenticator is a dynamic password tool that works similar to the SMS authentication. A verification code is generated every 30s after binding. The verification code can be used for security verification of operations such as login, withdrawal, and changing security settings.',
  'labels.acc.ga.desc3': 'Scan the following verification code using Google Authenticator',
  'labels.acc.ga.desc4':
    'If you cannot scan the QR code, you can manually enter the following 16-digit key into the Google verification app',
  'labels.acc.ga.desc5':
    'The key is used to retrieve the Google Authenticator when the phone is replaced or was lost. Be sure to back up and save the following key before binding',
  'labels.acc.ga.setupSuccess': 'Google verification was successfully set up',
  'labels.acc.ga.step1': 'Download and install Google Validator APP ',
  'labels.acc.ga.step2': 'Scan QR code',
  'labels.acc.ga.secret': 'Secret key',
  'labels.acc.ga.device': 'Device name',
  'labels.acc.notBind': 'Unbind',
  'labels.acc.bind': 'Bound',
  'labels.acc.loginPwd': 'Login Password',
  'labels.acc.loginPwd.desc':
    'It is used for system login. For the safety of your assets, no withdrawal or over-the-counter trading is allowed within 24H after the login password is reset.',
  'labels.acc.loginPwd.set': 'Set login password',
  'labels.acc.loginPwd.update': 'Update login password',
  'labels.acc.loginPwd.oldPwd': 'Old password',
  'labels.acc.loginPwd.newPwd': 'New password',
  'labels.acc.loginPwd.confirmNewPwd': 'Confirm new password',
  'labels.acc.loginPwd.confirmPwd': 'Confirm password',
  'labels.acc.loginPwd.googleValid': 'Google Authentication Code',
  'labels.acc.ga.txt.1': 'The system detected that you have not setup google authentication.',
  'labels.acc.ga.setup': 'Please proceed to setup!',
  'labels.acc.idVerf': 'ID Verification',
  'labels.acc.idVerf.rejected': 'Rejected',
  'labels.acc.idVerf.verified': 'Verified',
  'labels.acc.idVerf.pending': 'Pending',
  'labels.acc.idVerf.plsCompLvl1': 'Please complete Level 1 verification',
  'labels.acc.idVerf.verifyNow': 'Verify now',
  'labels.acc.idVerf.maxRegist': 'Use MAX-Wallet App verification',
  'labels.acc.idVerf.lvl1': 'LV 1',
  'labels.acc.idVerf.lvl1.desc': 'Identity documents or passport and biometrics. ',
  'labels.acc.idVerf.lvl2': 'LV 2',
  'labels.acc.idVerf.lvl2.desc': 'Advanced Verification',
  'labels.acc.txnPwd': 'Transaction Password',
  'labels.acc.confirmTxnPwd': 'Confirm transaction password',
  'labels.acc.partnership': 'Partnership',
  'labels.acc.partnership.desc': 'Please ask word to display',
  'labels.acc.partnership.pendingUpgrade': 'Pending Upgrade {title}',
  'labels.acc.partnership.expiredUpgrade': 'Expired',
  'labels.acc.txnPwd.desc': 'When the account funds change, you need to verify the transaction password first. ',
  'labels.acc.txnPwd.desc2':
    'Used for login, trading, internal transfers, and withdrawals. When the account funds change, verify the transaction password first. ',
  'labels.acc.txnPwd.setup': 'Setup transaction password',
  'labels.acc.txnPwd.modify': 'Reset transaction password',
  'labels.acc.txnPwd.old': 'Old transaction password',
  'labels.acc.txnPwd.new': 'New transaction password',
  'labels.acc.txnPwd.confirmNew': 'Confirm new transaction password',
  'labels.acc.mobile.verf': 'Phone Verification',
  'labels.acc.bindNow': 'Bind Now',
  'labels.acc.unbindNow': 'Unbind Now',
  'labels.acc.notSetup': 'Set up Incomplete',
  'labels.acc.setup': 'Complete',
  'labels.acc.side.affiliate': 'Affiliate Program',
  'labels.acc.side.accMsgs': 'Account Information',
  'labels.acc.side.accMgmt': 'Account Management',
  'labels.acc.side.mobileVerf': 'Phone Verification',
  'labels.acc.side.idVerf': 'ID Verification',
  'labels.acc.side.myReward': 'My Reward',
  'labels.acc.side.userCenter': 'Personal Centre',
  'labels.acc.side.loginRecord': 'Login Record',
  'labels.acc.side.maxRegister': 'Authorize MAX-Wallet',
  'labels.acc.side.relationTree': 'Member Relationship',
  'labels.acc.invite.desc1':
    'Invite friends to register on GRXTrade to enjoy commission on transaction fees and annual fee rebates',
  'labels.acc.invite.desc2': "Get 20% rebate for friends' processing fee and 20% rebate for annual membership fee",
  'labels.acc.invite.step1.desc1': 'Send invitation to friend',
  'labels.acc.invite.step1.desc2': 'Invitation to register on GRXTrade by sharing link / QR code / invitation code',
  'labels.acc.invite.step2.desc1': 'Referral Registration',
  'labels.acc.invite.step2.desc2': 'Referral accept invitation to complete registration and conduct currency transactions',
  'labels.acc.invite.step3.desc1': 'Receive the corresponding rebates',
  'labels.acc.invite.step3.desc2': "Enjoy commission from referral's transaction fees and annual membership rebates",
  'labels.acc.invite.enterCode': 'Enter invitation code',
  'labels.acc.invite.inexchangabledesc':
    'An existing user’s referral code becomes permanently fixed (un-editable) once s/he has successfully referred or invited a new user',
  'labels.acc.invite.code': 'Invitation code',
  'labels.acc.invite.qrCode': 'QR code',
  'labels.acc.invite.download.qrCode': 'Download the QR code',
  'labels.acc.invite.mySharing': 'My exclusive sharing method',
  'labels.acc.invite.registerLink': 'Register Link',
  'labels.acc.invite.registerTotal': 'Total number of invites',
  'labels.acc.invite.kycTotal': 'Real-name verified users',
  'labels.acc.invite.activityDetail': 'Activity Information',
  'labels.acc.invite.downlineAcc': 'Invitee Account',
  'labels.acc.invite.noReferral': `Don't have referrer?`,
  'labels.acc.invite.noReferral.confirm': `Confirm that you do not have referrer?`,
  'labels.acc.invite.history': 'Invite History',
  'labels.acc.inboxMsg.notification': 'Notification',
  'labels.acc.inboxMsg.readMsg': 'Read Message',
  'labels.acc.inboxMsg.unreadMsg': 'Unread Message',
  'labels.acc.inboxMsg.msg': 'Message',
  'labels.acc.inboxMsg.title': 'Title',
  'labels.acc.inboxMsg.deleteMsg.title': 'Delete Message',
  'labels.acc.inboxMsg.deleteMsg.desc': 'are you sure you want to delete this message?',
  'labels.acc.loginRecord.loginIp': 'IP Address',
  'labels.acc.loginRecord.security': 'Security Settings',
  'labels.acc.loginRecord.tag1': 'Login History',
  'labels.acc.loginRecord.tag2': 'Security Setup History',
  'labels.acc.maxRegister': 'Authorize MAX-Wallet',
  'labels.acc.maxRegister.desc': '',
  'labels.acc.maxRegister.setupSuccess': 'MAX-Wallet was successfully',

  // TODO :: Translate Chinese (affiliate)
  'labels.acc.myRwd.tradingBonus': 'Trading Bonus',
  'labels.acc.myRwd.enjoyNow': 'Enjoy 100% annual fee rebate towards trading activities',
  'labels.acc.myRwd.digitalClubReward': 'Digital Club Reward',
  'labels.acc.myRwd.howRedeem': 'How to redeem?',
  'labels.acc.myRwd.access': 'Courses are introduced by collaborative specialists, only made available for GRXTrade top/senior members and partners for learning purposes.',
  'labels.acc.myRwd.access-2.1': `For more courses, download the latest version of our `,
  'labels.acc.myRwd.access-2.2': ` and check out GRXTrade, variety of free online learning courses awaits. Join now!`,
  'labels.acc.myRwd.access.dclub': 'DCLUB APP',
  'labels.acc.myRwd.download.app': 'Download DCLUB',
  'labels.acc.myRwd.trustedTeam': 'Trusted Team Training',
  'labels.acc.myRwd.commission': 'Commission Fees Shared with You',
  'labels.acc.myRwd.clickHere': 'Click Here',
  'labels.acc.myRwd.memberFee': 'Member Fee',
  'labels.acc.myRwd.couponCode': 'Coupon Code:',
  'labels.acc.myRwd.expiredDate': 'Expired Date:',
  'labels.acc.myRwd.understandMore': 'understand more',

  'landing.appForm.title': `Thank you for your interest<span style="font-family:'Open Sans', sans-serif;font-weight: 100;"> in GRXTrade</span>`,
  'landing.appForm.desc': `Please fill out the application form with valid information and submit your application form to: <a class="color-blue" href="mailto:support@grxtrade.com">support@grxtrade.com</a>`,
  'landing.appForm.downloadBtn': 'Online Application Form',
  'landing.appForm.about.1': 'We will review your project based on the information you have submitted. If there are discrepancies in the information, or if we find invalid or false representation , your project will not be considered for listing on GRXTrade.',
  'landing.appForm.about.2': 'When you have satisfied the initial review, an Account Manager will be assigned to you to facilitate with the listing process. ',
  'landing.appForm.tip.title': 'Application Tips:',
  'landing.appForm.tip.1': 'Complete the form in its entirety, and with concrete and specific examples. Avoid exaggerated or vague statements.',
  'landing.appForm.tip.2': 'Organize and structure your points in a coherent and logical manner and provide evidence from credible, independently verifiable sources.',
  'landing.appForm.tip.3': 'This online listing application form is the only way to request a new addition to GRXTrade. Do not reach out through other channels, such as email or social media, because you will always be directed to this form.',
  'landing.appForm.tip.4': 'Please refrain from sending multiple request tickets to our team members on social media or private emails/other GRXTrade departmets. Doing so will only create longer queue of requests, which may further delay a response from our team.',
  'landing.appForm.tip.5': 'Any attempt to "spam" the request form (or incite other entities into doing so on your behalf) is strongly discouraged ad may result in the blacklisting of your project.',


  'landing.market.title': 'Easy access to all markets',
  'landing.video.title': 'A Next-generation Digital Asset Financial Service Provider',
  'landing.market.viewMore': 'View more markets',
  'landing.exp.title': 'Experience One-Stop Digital Asset Trading Platform',
  'landing.exp.title.desc':
    'New user-centric digital asset exchange with the lowest trading fees and most comprehensive Affiliate program.',
  'landing.exp.sec.1': 'Complete digital asset trading solution centre',
  'landing.exp.sec.2': 'LOWEST trading fees in town',
  'landing.exp.sec.3': 'Comprehensive Affiliate Program',
  'landing.exp.sec.4': 'Exceptional platform security features',
  'landing.exp.sec.5': 'Customer Support service',
  'landing.exp.desc.1': 'Multiple trading options and most sought-after trading pairs available',
  'landing.exp.desc.2': 'Highly competitive trading fees starting as low as 0.04%',
  'landing.exp.desc.3': 'Earn up to 40% cumulative commision passive income from active referrals',
  'landing.exp.desc.4':
    'Integration of MAX-Wallet and CipherTrace® system for enhanced security and comprehensive digital asset intelligence',
  'landing.exp.desc.5': 'Prompt and efficient customer service',
  'landing.exp.whyG.1':
    'At GRXTrade, we strive to raise the bar by offering international markets and traders with top-of-the-line market trading fees and the most sought-after trading pairs. Our exchange platform has shared liquidity through a network of exchanges out there, eliminating possible risks of low liquidity issues.',
  'landing.exp.whyG.2':
    'Regardless of you being an advanced trader or a beginner, GRXTrade grants you the power to chart your own financial course. Our exchange platform has an ever-growing number of digital asset pairs for you to invest in, along with a wide range of tools and features for you to leverage on to grow your portfolio.',
  'landing.exp.whyG.3':
    'GRXTrade is a user-centric platform. In this industry, we understand what security means to users. For enhanced protection, we work with formidable partners for added layers of trust and safety.',
  'landing.exp.whyG.subtitle1.desc':
    'GRXTrade incorporates the MAX-Wallet, a mobile application built upon the Maxonrow blockchain known for its innovative real-name KYC and AML compliant mechanism.',
  'landing.exp.whyG.subtitle2.desc':
    'CipherTrace is a leading digital asset intelligence founded by experienced Silicon Valley entrepreneurs to develop digital asset and blockchain tracing and security capabilities to enable a thriving blockchain economy.',
  'landing.exp.whyG.4': 'Invest today for your future with GRXTrade.',
  'landing.getStarted.title': 'Get started with GRXTrade App for free',
  'landing.getStarted.desc':
    'Stay connected with the latest charts and markets using our Android and iOS apps or you can trade from your desktop using our specialised platform for Mac or Windows.',
  'landing.getStarted.sec.1': 'Manage your favourite market',
  'landing.getStarted.sec.2': 'Security Authentication',
  'landing.getStarted.sec.3': 'Buy and sell assets',
  'landing.getStarted.desc.1': 'All the power of a comprehensive digital asset exchange, in the palm of your hand.',
  'landing.getStarted.desc.2':
    'Multiple identity authentication, KYC mechanism, login security protection, wallets regular maintenance.',
  'landing.getStarted.desc.3':
    'Our high-liquidity exchange ensures that your trade orders are executed quickly and at the price you want.',
  // 'landing.think.title': 'Need time to think it over?',
  'landing.think.title.desc': "Explore other features on GRXTrade's platform",
  'landing.think.sec.1': 'Affiliate Program',
  'landing.think.sec.1.coming': '(Coming Soon)',
  'landing.think.sec.2': 'Trading Fees',
  'landing.think.desc.1': 'Learn more about our Affiliate Program today',
  'landing.think.desc.2': 'Get familiar with our Trading Fees structure',
  'landing.partner.join': 'Join ',
  'landing.partner.title': 'Our Partners',
  'landing.partner.cipher.text':
    'Fostering trust and safety within the digital asset economy with trusted blockchain security firm, CipherTrace®.',
  'landing.partner.wallet.text': 'Reinforced safety and compliance with leading blockchain security compliance',
  'landing.partner.wallet.link': 'MAX-Wallet',

  'login.welcome': 'Welcome',
  'login.forgotPwd': 'Forgot Password',
  'login.loggingIn': 'Logging in',
  'login.registerForFree': 'Free Registration',
  'login.dontHaveAcc': "Don't have an account?",
  'login.success': 'You have logged in successfully',
  // TODO :: translate chinese start
  'login.userActivation': 'User Activation',
  // TODO :: translate chinese end

  'market.list.table.header.pair': 'Pair',
  'market.list.table.header.lastPrice': 'Last Price',
  'market.list.table.header.24HChange': '24H Change',
  'market.list.table.header.24HHigh': '24H High',
  'market.list.table.header.24HLow': '24H Low',
  'market.list.table.header.24HVol': '24H Volume',

  'max.register.title.login': 'MAX-Wallet Login',
  'max.register.title.registration': 'MAX-Wallet Registration',
  'max.register.title.kyc': 'KYC using MAX-Wallet',
  'max.register.title.bind': 'Authorize MAX-Wallet Login',
  'max.register.desc.login': 'Use MAX-Wallet App to login or download now',
  'max.register.desc.bind': 'Authorize MAX-Wallet login or download now',
  'max.register.desc.registration': 'Use MAX-Wallet App to register or download now',
  'max.register.desc.kyc': 'To continue, Max-Wallet will share your identity information with grxtrade.com',
  'max.register.subDesc.kyc': `Before using this app, you can review grxtrade.com's <a href="/legal/terms-of-use" target="_blank" style="color: #1E49AC">Terms of Use</a>`,
  'max.register.question': 'Questions? Visit our ',
  'max.register.helpCenter': 'Help Center',
  'max.register.iAgree': 'I agree to share my KYC details with GRXTrade',
  'max.register.step1': 'Open the MAX-Wallet',
  'max.register.step2': 'On the top menu',
  'max.register.step3': 'Point the camera at the QR Code ',

  'promoMaxRegModal.title': 'Make Life Simpler',
  'promoMaxRegModal.desc': 'For the fastest and easiest way to access GRXTrade, we recommend signing up for MAX-Wallet.',
  'promoMaxRegModal.explain': 'With MAX-Wallet*, you can enjoy these in GRXTrade:',
  'promoMaxRegModal.benefit1': 'One-click Registration',
  'promoMaxRegModal.benefit2': 'One-click Login',
  'promoMaxRegModal.benefit3': 'Instant KYC Approval',
  'promoMaxRegModal.benefit6': '* You need to get the latest MAX-Wallet',
  'promoMaxRegModal.unableDownload': 'Unable to download app?',
  'promoMaxRegModal.downloadLink': `<span style="font-size: 14px">Please try to <a href="{ios}" target="_blank" style="color: #1E49AC">Download iOS IPA</a> or <a href="{android}" target="_blank" style="color: #1E49AC">Download Android</a></span>`,
  'promoMaxRegModal.downloadNow': 'Download MAX-Wallet',
  'promoMaxRegModal.registerPage': 'Back to email registration',
  'promoMaxRegModal.continueWithMaxWallet': 'Continue With MAX-Wallet',
  'promoMaxRegModal.here': 'Here',

  'partnerInvite.joinPartnerProgram.desc':
    'To continue, MAX-Wallet will share your Identity Information with grxtrade.com. Before using this app, you may review our terms of Use.',
  'partnerInvite.joinPartnerProgram.partnerLevel': 'Partner Level:',
  'partnerInvite.joinPartnerProgram.balance': 'My Asset Balance:',
  'partnerInvite.joinPartnerProgram.fee': 'Join Fee:',
  'partnerInvite.joinPartnerProgram.termsAndCondition': `By clicking on this, you agree to <a href="/legal/partner-policy" target="_blank" style="color: #1E49AC">Partner's Terms of Conditions</a>`,
  'partnerInvite.joinPartnerProgram.mustCheckText': 'You must agree with the terms and condition to proceed',

  'maxRegisterModal.title': 'Register with MAX-Wallet',
  //  'maxRegisterModal.desc': 'To continue, MAX-Wallet will share your Identity Information with grxtrade.com. Before using this app, you can review grxtrade.com’s terms of Use.',
  'maxRegisterModal.desc': 'If you have completed KYC with MAX-Wallet, you can enjoy registration with instant KYC approval.',
  // 'maxRegisterModal.desc': 'If you completed KYC on MAX-Wallet, you can instant get your KYC approve here.',
  'maxRegisterModal.scanQrCode': 'Scan this QR Code with MAX-Wallet to register',
  'maxRegisterModal.agreeAndContinue': "Sure, let's do it",
  'maxRegisterModal.registerWithoutKyc': 'Register without KYC',

  'register.registration': 'Welcome to GRXTrade',
  'register.registration.select': 'Select a registration method to continue.',
  'register.registration.withEmail': 'Register with Email',
  'register.registration.withMaxWallet': 'Register with MAX-Wallet',
  'register.inviteCode': 'Invitation Code (Optional)',
  'register.alreadyRegist': 'Already registered?',
  'register.termAndUsePrivacyPolicy': `By creating an account, I agree to GRXTrade’s <a href="/legal/terms-of-use" target="_blank" style="color: #1E49AC">Terms of Use</a> and <a href="/legal/privacy-policy" target="_blank" style="color: #1E49AC">Privacy Policy</a>.`,
  'register.success': 'Congratulations，your registration is successful!',

  'sto.payment.title': 'Order Summary',

  'sto.listing.about.title': 'STO - Security Token Offering',
  'sto.listing.about.desc.1': `Security tokens are basicaaly an infrastructuaral solutions to increase liquidity in the market - they are an electronic wrapper for things that were traditionally stroted on paper, like electronic mail is to conventional mail.`,
  'sto.listing.about.desc.2': `At the moment, the infrastucture required for global implementation of tokenized securities does not yet exist on a big enough scale, however mutiple companines are building innovative services in order to capitalize on this new blockchain trend.`,
  'sto.listing.about.desc.3': `Please read and agree to GRXTrader's Terms of Use and Privacy Policy before you enter this platform. GRXTrader shall not be liable for any loss or damage caused as the result of using aforementioned service.`,
  'sto.listing.banner.apply.txt': 'Apply For New STO',
  'sto.listing.dashMenu.application': 'My Applications',
  'sto.listing.dashMenu.project': 'My Project',
  'sto.listing.dashMenu.investment': 'Investment',
  'sto.listing.filter.all': 'All',
  'sto.listing.filter.on.going': 'On Going',
  'sto.listing.filter.ended': 'Ended',
  'sto.listing.filter.search': 'Search',
  'sto.listing.filter.completed': 'Completed',
  'sto.listing.filter.myDraft': 'My Draft',
  'sto.listing.listBlock.preSale': 'On Going Private Pre-sale',
  'sto.listing.listBlock.endIn': 'Ends in',
  'sto.listing.listBlock.days': 'day(s)',
  'sto.listing.totalOf': 'A total of',
  'sto.listing.token.found': 'Security Token Offering Found',
  'sto.listing.menu.all': 'All STO',
  'sto.listing.menu.intro': 'What is STO?',
  'sto.listing.menu.dashboard': 'My Dashboard',
  'sto.listing.agreement.notice': 'I have read and acknowledge the notice',
  'sto.listing.agreement.enter': 'ENTER',
  'sto.details.STO': 'STO',
  'sto.details.overview.unable.edit': 'Unable to edit',
  'sto.details.overview.edit.proj': 'Edit Project',
  'sto.details.overview.request.rejected': 'Your update request has been rejected',
  'sto.details.overview.back.proj': 'Back to Project',
  'sto.details.overview.save.proj': 'Save Project',
  'sto.details.overview.rejected.reason': 'Your application has been rejected for the following reason',
  'sto.details.overview.err': 'error',
  'sto.details.overview.campaign.by': 'Fundraising campaign by',
  'sto.details.overview.campaign.owner': 'Marco Neukom',
  'sto.details.overview.chg.photo': 'Change Photo',
  'sto.details.overview.upload.file': 'Uploading file',
  'sto.details.overview.token.photo': 'Token Photo',
  'sto.details.overview.comp.overview': 'Company Overview',
  'sto.details.overview.share': 'Share',
  'sto.details.overview.twitter': 'Twitter',
  'sto.details.overview.facebook': 'Facebook',
  'sto.details.overview.weibo': 'Weibo',
  'sto.details.overview.wechat': 'Wechat',
  'sto.details.overview.telegram': 'Telegram',
  'sto.details.overview.linkedin': 'Linkedin',
  'sto.details.overview.token.details': 'Token Details',
  'sto.details.overview.symbol': 'Symbol',
  'sto.details.overview.token.type': 'Token Type',
  'sto.details.overview.document': 'Document',
  'sto.details.overview.business.proposal': 'Business Proposal',
  'sto.details.overview.upload.document': 'Upload Document',
  'sto.details.overview.reason': 'Reason',
  'sto.details.overview.submitted.unable.edit': 'Once submitted you will not be able to edit this project for at least 3-5 days.',
  'sto.details.editModal.display.photo': 'Display Photo',
  'sto.details.editModal.update.reason': 'Reason for updating details',
  'sto.details.nothing.here': 'There is nothing here',
  'sto.details.list.overview': 'Overview',
  'sto.details.list.overview.sto.dates': 'STO Dates',
  'sto.details.list.overview.current.stage': 'Current Stage',
  'sto.details.list.overview.funding': 'Funding',
  'sto.details.list.overview.for.sale': 'For Sale',
  'sto.details.list.overview.sto.price': 'STO Price',
  'sto.details.list.overview.raised': 'Raised',
  'sto.details.list.overview.add.watchlist': 'Add to Watchlist',
  'sto.details.list.overview.promo.code': 'Promo Code',
  'sto.details.list.overview.min.investment': 'Minimum Investment',
  'sto.details.list.overview.invest.now': 'Invest Now',

  'trade.buy.success': 'place buy order success',
  'trade.sell.success': 'place sell order success',
  'trade.cancel.confirm': 'Are you sure you want to cancel this order?',
  'trade.cancel.success': 'Order has been cancelled successfully',
  'trade.match.success': 'Order has been matched {number}',

  'v.r.advance.address.building': 'Field cannot be empty',
  'v.r.advance.address.street': 'Field cannot be empty',
  'v.r.advance.address.district': 'Field cannot be empty',
  'v.r.advance.address.province': 'Field cannot be empty',
  'v.r.advance.address.zipCode': 'Field cannot be empty',
  'v.r.advance.address.city': 'Field cannot be empty',
  'v.r.advance.address.countryCode': 'Field cannot be empty',
  'v.r.advance.address.authImgUrl1': 'Field cannot be empty',
  'v.advance.submit.success': 'Advanced verification has been submitted successfully',
  'v.advance.submit.error': 'Please save Residential Address and Employment Information before submitting',

  'v.common.pwd.required': common.plsEnter + 'password',
  'v.common.pwd.pwdValid':
    'The password format is incorrect. The password must be between 6-20 characters in length and contain uppercase letters + lowercase letters + numbers',
  'v.common.pwd.pwdValid.note':
    'The password must be between 6-20 characters in length and contain uppercase letters + lowercase letters + numbers',
  'v.common.oldPwd.required': common.plsEnter + 'old password',
  'v.common.newPwd.required': common.plsEnter + 'new password',
  'v.common.secondPwd.required': 'Please retype password',
  'v.common.secondPwd.sameAs': 'Two passwords must be the same',
  'v.common.txnPwd.required': common.plsEnter + 'transaction password',
  'v.common.txnPwd.format':
    'The password format is incorrect. The password must be between 6-20 characters in length and contain uppercase letters + lowercase letters + numbers',
  'v.common.txnPwd.format.note':
    'The password must be between 6-20 characters in length and contain uppercase letters + lowercase letters + numbers',
  'v.common.txnPwd.notsame': 'Your new transaction password cannot be the same as your old transaction password',
  'v.common.txnPwd.retype': 'Please enter your transaction password again',
  'v.common.payPwd.wrong': 'Password format is incorrect, password length must be equal to 6 alphanumeric codes',
  'v.common.email.required': common.plsEnter + 'email',
  'v.common.email.format': 'Incorrect email format',
  'v.common.otp.required': common.plsEnter + 'OTP',
  'v.common.otp.verifyCode': 'Incorrect OTP format',
  'v.common.country.required': common.plsSelect + 'country',
  'v.common.gaCode.required': common.plsEnter + 'google verification code',
  'v.common.gaCode.format': 'Incorrect google verification code format',
  'v.common.invite': common.plsEnter + 'invitation code',
  'v.common.kyc': 'Please complete real-name authentication / KYC first',
  'v.common.cannot.blank': ' cannot be blank',
  'v.common.ga.setup': 'You are required to setup google authentication before performing this action',
  'v.common.mobile.required': common.plsEnter + 'mobile number',
  'v.common.mobile.format': 'Incorrect mobile number format',
  'v.common.newMobile.required': common.plsEnter + 'new mobile number',
  'v.common.newMobile.cannot.same': 'New mobile and old mobile number cannot be the same',
  'v.common.setup.ga.before.trade': 'Please setup google authentication before you start trading',
  'v.common.setup.txnPwd.before.trade': 'Please setup transaction password before you start trading',
  'v.common.walletAddr.format': 'Invalid Wallet Address',
  'v.common.session.timeout': 'Session Timeout',

  'v.trade.volume.required': common.plsEnter + 'volume',
  'v.trade.price.required': common.plsEnter + 'price',
  'v.trade.price.min': 'Minimum Price:{priceMin}',
  'v.trade.price.max': 'Maximum Price:{priceMax}',
  'v.trade.amount.insufficientBalance': 'insufficient balance',

  'success.copy': 'Copied successfully',
  'success.resetPwd': 'Password has been reset successfully',
  'success.reactivatePwd': 'Your account has been reactivated',
  'success.withdraw': 'Withdrawal successful',
  'success.withdraw.cancel': 'Withdrawal has been cancelled',
  'success.wallet.add': 'Wallet address has been added successfully',
  'success.wallet.delete': 'Wallet address has been deleted successfully',
  'success.ga.bind': 'Google authentication code bind successfully',
  'success.ga.unbind': 'Google authentication code unbind successfully',
  'success.invite': 'Invitation code has been added successfully',
  'success.loginPwd.set': 'Login password has been set successfully',
  'success.loginPwd.modify': 'Login password has been updated successfully',
  'success.phone.bind': 'Mobile number binding successful',
  'success.phone.unbind': 'Mobile number unbinding successful',
  'success.order.place': 'Order has been placed successfully',
  'success.txnPwd.set': 'Your transaction password is successfully set',
  'success.deleteMsg': 'Message deleted successfully',
  'success.bindMAXWallet': 'Bind MAX-Wallet Successfully',
  'success.allOrderCancel': 'All Order Cancel Successfully',
  'success.rejectPartnerInvitation': 'You have rejected invitation successfully',
  // TODO :: translate chinese start
  'success.affiliateInvite': 'Your application has been approved.',
  'success.partnerInvite': 'Your application has been approved.',
  'success.partnerInvite2': 'You have success submitted your request.',
  'success.verifyBtn': 'Sent verification code successfully',
  // TODO :: translate chinese end

  'teamProfile.title': 'LEADERSHIP',
  'teamProfile.person1': 'RYAN FELLAL',
  'teamProfile.person1.position': 'Chief Executive Officer',
  'teamProfile.desc.1': `Ryan is a derivatives specialist adept at imparting bespoke risk management and financing solutions supporting the ultra high net-worth individuals (UHNWI), corporates and private institutions. He built his career carving his niche in derivatives with the renowned Credit Suisse in Zurich, Switzerland and was later made an Associate Partner at the prestigious St. James’s Place Wealth Management being based in Shanghai, China.`,
  'teamProfile.desc.2': `An objective person with a penchant for adaptive communication, Ryan is a results-driven worker who is known for his quality deliverables to his clients. No stranger to Asia, his work has taken him to many Asian and Southeast Asian countries, infusing him with greater understanding and respect for the colorful cultures and traditions of the east.`,
  'teamProfile.desc.3': `Joining us as our CEO for GRXTrade, Ryan brings with him, vast investment and financial services advisory to scale our products to further heights.`,

  'warning.exceededPrice': 'Your price has exceeded the current price by (PERCENTAGE)',

  'dClub.title': 'DCLUB',
  'dClub.desc.1': 'GRXTrade offers you complimentary DCLUB learning opportunities.',
  'dClub.desc.2': 'Unable to download app? ',
  'dClub.step1': 'Click to download the APP',
  'dClub.step2': 'Register and login',
  'dClub.step3': 'Click "My" to select "Redemption Code"',
  'dClub.step4': 'Enter the redemption code to redeem the course',
  'dClub.hyperLink': `<span style="font-size: 14px">Please try to <a href="{ios}" target="_blank" style="color: #1E49AC">Download iOS IPA</a> or <a href="{android}" target="_blank" style="color: #1E49AC">Download Android</a></span>`,

  'registerSuccessfulModel.title': 'Congratulation!',
  'registerSuccessfulModel.desc':
    'Your account has been successfully created! <div> We recommend you that to download our mobile app now! </div>',
  'registerSuccessfulModel.unableToDownloadDesc': 'Unable to download app? ',
  'registerSuccessfulModel.hyperLink':
    'Please try to <a style="color: #1E49AC;">Download iOS IPA</a> or <a style="color: #1E49AC;">Download Android APK</a>',

  'downloadBox.title': 'GRXTrade App',

  'invitationPoster.registerNow': 'Register Now',
  dictionary: {},
  ...labels,
  ...maps,

  'actions.next': 'Next',
  'actions.payAndSubmit': 'Pay and Submit',
  'actions.viewFile': 'View File',
  'actions.describeProject': 'Describe your project',
  'actions.upload': 'Upload',
  'actions.chooseOrCreateToken': 'Choose or create your token',
  'actions.startOver': 'Start Over',
  'actions.continue': 'Continue',
  'common.search': 'Search',
  'common.share': 'Share',
  'common.viewMore': 'View More',
  'common.viewLess': 'View Less',
  'common.overview': 'Overview',
  'common.promoCode': 'Promo Code',
  'labels.tokenName': 'Token Name',
  'labels.tokenSymbol': 'Token Symbol',
  'labels.mxwToken': 'Max-Wallet Token',
  'labels.free': 'Free',
  'labels.tokenRequestFee': 'Token Request Fee',
  'labels.erc20Token': 'ERC-20 Token',
  'labels.success': 'Success',
  'labels.fail': 'Fail',
  'labels.backToHome': 'Back To Home',
  'labels.backToPayment': 'Back To Payment',
  'labels.pendingApproval': 'Pending Approval',

  //sto translations
  'sto.form.required': '{field} is required',
  'sto.form.numeric': 'Numeric only',
  'sto.form.alpha': 'Alphabets only',
  'sto.payment.orderId': 'Order ID',
  'sto.payment.date': 'Date',
  'sto.payment.accountId': 'Account ID',
  'sto.payment.accountFee': 'Account Fee',
  'sto.payment.totalAmount': 'Total Account',
  'sto.payment.tokenFee': 'Token Fee',
  'sto.payment.notes.ga': 'To confirm your application submission, you need to enter your Google Authenticator Code for payment',
  'sto.payment.notes.txnPwd': 'To confirm your application submission, you need to enter your Transaction Password for payment',
  'sto.payment.success': 'Your application is submitted successfully and pending review, it may take 3-5 working days.',
  'sto.payment.fail': 'Sorry, your application payment is unsuccessful!',
  'sto.payment.orderTxn': 'Order Transaction',
  'sto.payment.applicationFee': 'Application Fee',

  'sto': 'Security Token Offering',
  'sto.applySto': 'Apply For New STO',
  'sto.myDashboard': 'My Dashboard',
  'sto.myApplication': 'My Applications',
  'sto.myProject': 'My Project',
  'sto.myInvestment': 'My Investment',
  'sto.ongoing': 'On Going',
  'sto.ended': 'Ended',
  'sto.ongoingPreSale': 'On Going Private Pre-sale',
  'sto.remainingDays': 'Ends in {remainingDays} day(s)',
  'sto.remainingDays2': '{remainingDays} days left',
  'sto.updateRequestSent': 'Update request sent',
  'sto.unableToEdit': 'Unable to edit',
  'sto.editProject': 'Edit Project',
  'sto.updateRequestRejected': 'Your update request has been rejected',
  'sto.backToProject': 'Back to Project',
  'sto.saveProject': 'Save Project',
  'sto.updateRequestRejected2': 'Your application has been rejected for the following reason',
  'sto.fundraisingBy': 'Fundraising campaign by',
  'sto.changePhoto': 'Change Photo',
  'sto.uploading': 'Uploading file',
  'sto.tokenPhoto': 'Token Photo',
  'sto.companyOverview': 'Company Overview',
  'sto.tokenDetail': 'Token Details',
  'sto.tokenSymbol': 'Symbol',
  'sto.tokenType': 'Token Type',
  'sto.document': 'Documents',
  'sto.businessProposal': 'Business Proposal',
  'sto.uploadDocument': 'Upload Document',
  'sto.selectDocument': 'Select Document',
  'sto.updateDetailReason': 'Reason for updating details',
  'sto.reason': 'Reason',
  'sto.dates': 'STO Dates',
  'sto.currentStage': 'Current Stage',
  'sto.funding': 'Funding',
  'sto.forSale': 'For Sale',
  'sto.raised': 'Raised',
  'sto.addToWatchList': 'Add to Watchlist',
  'sto.minInvestment': 'Minimum Investment',
  'sto.investAmount': 'Investment Amount',
  'sto.investNow': 'Invest Now',
  'sto.chooseYourToken': 'Choose Your Token',

  'sto.listing.about.about1': 'Security tokens are basically an infrastructural solution to increase liquidity in the market - they are an electronic wrapper for things that were traditionally stored on paper, like electronic mail is to conventional mail.',
  'sto.listing.about.about2': 'At the moment, the infrastructure required for global implementation of tokenized securities does not yetexist on a big enough scale, however multiple companies are building innovative services in order to capitalize on this new blockchain trend.',
  'sto.listing.about.about3': 'Please read and agree to GRXTrade’s Terms of Use and Privacy Policy before you enter this platform. GRXTrade shall not be liable for any loss or damage caused as the result of using aforementioned service.',
  'sto.listing.about.agree': 'I have read and acknowledge the notice',
  'sto.listing.about.enter': 'ENTER',

  'sto.listing.pagination.totalRecord': 'A total of {totalRecords} Security Token Offering Found',

  'sto.listing.menu.allSto': 'All STO',
  'sto.listing.menu.whatIsSto': 'What is STO?',

  'sto.project.editNotice': 'Once submitted you will not be able to edit this project for at least 3-5 days.',

  'sto.fundraiser.application.title': 'Application Form for STO Fundraising',

  'sto.form.companyDetais': 'Company Details',
  'sto.form.shareholderDetails': 'Shareholder Details',
  'sto.form.directorDetails': 'Director Details',
  'sto.form.fundraisingDetails': 'Fund Raising Details',
  'sto.form.allFieldsRequired': 'All fields are required',
  'sto.form.countryIncorp': 'Country of Incorporation',
  'sto.form.companyRegNo': 'Company Registration Number',
  'sto.form.bizNature': 'Nature of Business',
  'sto.form.companyMemorandum': 'Memorandum & Articles of Association / Constitutions Or Any Other Equivalent Documents',
  'sto.form.companyCert': 'Company Certificate of Incorporation',
  'sto.form.address': 'Address',
  'sto.form.city': 'City',
  'sto.form.state': 'State',
  'sto.form.postcode': 'Postcode',
  'sto.form.country': 'Country',
  'sto.form.maxUser': 'Max {maxUser} person',
  'sto.form.shareholderName': 'Shareholder Name',
  'sto.form.identityNo': 'Identity Card',
  'sto.form.ownershipPercentage': 'Percentage of Ownership',
  'sto.form.shareholderDocument': 'Certified True Copies of Passport Document',
  'sto.form.removeShareholder': 'Remove Shareholder',
  'sto.form.addShareholder': 'Add Another Shareholder',
  'sto.form.totalShareholder': 'Total Shareholder',
  'sto.form.totalPercentage': 'Total Percentage',
  'sto.form.directorName': 'Director Name',
  'sto.form.idOrPassport': 'Identity Card No / Passport No',
  'sto.form.uploadIdOrPassport': 'Upload Identity Card No / Passport No',
  'sto.form.addDirector': 'Add Another Director',
  'sto.form.removeDirector': 'Remove Director',
  'sto.form.fundraisingTitle': 'Fund Raising Title',
  'sto.form.title': 'Title',
  'sto.form.fundUnit': 'Fund Unit',
  'sto.form.totalFundToRaise': 'Total Amount to be raised',
  'sto.form.tokenToRaise': 'Number of token to issue',
  'sto.form.tokenToKeep': 'Number of token to keep',
  'sto.form.fundraisingDuration': 'Duration of Fund Raising',
  'sto.form.fundraising.successCriteria': 'Criteria for Successful Fund Raising',
  'sto.form.fundraising.successCriteria2': 'Minimum Amount of Fund Raised Accepted',
  'sto.form.underwriterCommission': 'Underwriter Commission',
  'sto.form.underwriterCommission2': '% of the total amount of fund raised',
  'sto.form.affiliateCommission': 'Affiliate Program Commission',
  'sto.form.affiliateCommission2': '% of The Total Amount of Fund Raised',
  'sto.form.commissionNote': 'Note: for more successful fund raising exercise, fundraiser should choose to give out a percentage of the total fund raised as commission to the affiliates who try to refer other investors to invest in the project.',
  'sto.form.investmentValueLabel': 'Investment Value For Investor',
  'sto.form.minInvestAmt': 'Min Investment Value',
  'sto.form.maxInvestAmt': 'Max Investment Value',
  'sto.form.fundraisingDurationByMonth': '{duration} month',
  'sto.form.document.notes': 'STO Issuer are required to submit 1 Business Proposal document to be published on the GRX STO platform for the investors to make informed investment decision. Such documents must be accurate in content,no false and misleading information.',
  'sto.form.document.notes2': 'We reserves the right to blacklist STO Issuer if such false and misleading information are found.',
  'sto.form.document.notes3': 'The Business Proposal document should cover, but not limited to the below content:',
  'sto.form.document.notes4': 'Only supports docx, jpg, pdf, jpeg, png. File size maximum 5MB.',
  'sto.form.bizProposal': 'Business Introduction / Business Model / Unique Value Proposition / Revenue Stream Financial Forecasts (3 Years and 5 Years)',
  'sto.form.displayPhoto': 'Display Photo',
  'sto.form.projSummary': 'Summary of the project / Project Introduction Page',
  'sto.form.svcLic': 'SVC License',
  'sto.form.mxw.note': 'To continue, Max-Wallet will share your Identity Infomation with grxtrade.com. Before using this app, you can review grxtrade.com\'s',
  'sto.form.mxw.termOfUse': 'Terms of Use.',
  'sto.form.walletAddress': 'Wallet Address',
  'sto.form.requesterName': 'Requester Name',
  'sto.form.requesterEmail': 'Requester Email Address',
  'sto.form.contractAddress': 'Contract Address',
  'sto.form.crowdSale': 'CrowdSale/ICO/Token Sales Address',
  'sto.form.offUrl': 'Official Site URL',
  'sto.form.logoLink': 'Link to download a 28x28 png icon logo',
  'sto.form.logoLink2': 'Logo Download Link',
  'sto.form.officialContractEmail': 'Official Contact Email Address',
  'sto.form.tokenDesc': 'Short Project Description ({limit} words or less)',
  'sto.form.tokenDesc2': 'Project Description',
  'sto.form.blogLink': 'Link To Blog',
  'sto.form.redditLink': 'Link To Reddit',
  'sto.form.slackLink': 'Link To Slack',
  'sto.form.fbLink': 'Link To Facebook',
  'sto.form.twitterLink': 'Link To Twitter',
  'sto.form.btLink': 'Link To Bitcointalk',
  'sto.form.githubLink': 'Link To Github',
  'sto.form.telegramLink': 'Link To Telegram',
  'sto.form.wechatLink': 'Link To Wechat',
  'sto.form.linkedInLink': 'Link To Linkedin',
  'sto.form.discordLink': 'Link To Discord',
  'sto.form.whitepaperLink': 'Link To Whitepaper',
  'sto.form.coinMarketLink': 'Coin marketcap link',
  'sto.form.comment': 'Comment',
  'sto.form.tokenInfo': 'Token Information',
  'sto.form.projectSector': 'Project Sector',
  'sto.form.totalTokenSupply': 'Token Total Supply',
  'sto.form.totalCap': 'Total Cap',
  'sto.form.icoStartDate': 'ICO Start Date',
  'sto.form.icoEndDate': 'ICO End Date',
  'sto.form.resumeApplication': 'Resume Your Application',
  'sto.form.resumeApplication.note': 'Looks like you already started create an application. Would you like to continue or start over?',

  'sto.waitPayment.note': 'Please wait, your order is being processed. Please do not close the page.',

  'sto.error.tokenIssueGreaterThanTokenKeep': 'Must be greater than token to keep',
  'sto.error.tokenKeepLessThanTokenRaise': 'Must be less than token to raise',
  'sto.error.lessThanTotalFundToRaise': 'Must be less than total fund to raise',
  'sto.error.lessThanMaxInvestAmt': 'Must be less than max invest amount',
  'sto.error.moreThanMinInvestAmt': 'Must be more than min invest amount',
  'sto.error.maxLength': 'Cannot exceed more than {limit} characters',
  'sto.error.maxWords': 'Cannot exceed more than {limit} words',
  'sto.error.mustBe': 'Value must be {limit}',
  'sto.error.maxSize': 'File size exceeded {limit}',
  'sto.error.onlyPdf': 'Invalid file type. Only accepts image file',
  'sto.error.onlyImage': 'Invalid file type. Only accepts pdf file',
  'sto.error.beforeDate': 'Must be before {limit}',
  'sto.error.afterDate': 'Must be afer {limit}',

  'labels.investedAmt': 'Invested Amount',
  'labels.refNo': 'Reference No',

  'sto.listing.filter.myRework': 'My Rework',
  'sto.labels.requireRework': 'This application requires a rework',
  'sto.labels.reworkApplySuccess': 'Rework application submitted',
  'sto.labels.isRejected': 'This application has been rejected',
  'sto.labels.pendingPayment': 'Pending Payment',
  'sto.labels.units': 'unit(s)'
};
